<template>
<section class="flex flex-col md:flex-row items-center px-6 sm:px-12 py-12 md:py-0 bg-gray-50">
    <!-- Left Column: Black and White Image -->
    <div class="w-full md:w-1/2 flex justify-center md:justify-end lg:p-12 pb-8">
      <img 
        src="../assets/photos/about_me_georgina.JPG" 
        alt="About Us" 
        class="object-cover grayscale sm:pb-4" 
      />
    </div>

    <!-- Right Column: Text -->
    <div class="w-full xl:w-2/5 p-8 md:p-16 text-center">
      <h2 class="text-3xl sm:text-4xl font-medium mb-4 text-gray-800 pb-0 font-serif">A Little About Me</h2>
      <p class="text-md md:text-lg leading-relaxed text-gray-700 sm:text-md sm:leading-loose">
        Hello! I'm Georgina, the one-woman-show behind this creative studio in Leeds. I pour my heart into every piece I create, from Yorkshire weddings to international celebrations.
      </p>
      <br>
      <p class="text-md md:text-lg leading-relaxed text-gray-700 sm:text-md sm:leading-loose">
        When I’m not designing, I’m with my four-legged “assistant” Cooper, a mischievous pup who thinks he runs the show! He keeps me company while I hand-assemble each order.
      </p>
      <br>
      <p class="text-md md:text-lg leading-relaxed text-gray-700 sm:text-md sm:leading-loose">
        I’d love to help make your vision come to life, creating stationery that captures the spirit of your special day with a personal touch.
      </p>
    </div>
</section>
</template>

<script>

export default {
  name: 'AboutSection',
  components: {

  },
}


</script>

<style scoped>
img {
    max-height: 550px;
}


</style>
